var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2226 21.1271C18.1413 22.8849 15.4414 24.0005 12.5022 24.0005C8.12881 24.0005 4.2897 21.5911 2.2085 18.0755L2.98765 14.4839L6.44131 13.8428C7.24287 16.4302 9.66157 18.3287 12.5022 18.3287C13.8803 18.3287 15.1601 17.8927 16.2147 17.1193L19.5335 17.6255L20.2226 21.1271Z",
    fill: "#59C36A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2203 21.1269L19.5312 17.6254L16.2125 17.1191C15.1578 17.8926 13.8781 18.3285 12.5 18.3285V24.0003C15.4391 24.0003 18.1391 22.8847 20.2203 21.1269Z",
    fill: "#00A66C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17187 12.0036C6.17187 12.6505 6.27031 13.2692 6.43906 13.8458L2.20625 18.0786C1.15156 16.3067 0.5 14.2254 0.5 12.0036C0.5 9.78175 1.15156 7.70057 2.20625 5.92871L5.60342 6.51338L6.43906 10.1615C6.27031 10.738 6.17187 11.3567 6.17187 12.0036Z",
    fill: "#FFDA2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12C24.5 15.6561 22.8079 18.9327 20.2203 21.1264L16.2125 17.1187C17.0281 16.528 17.7172 15.7405 18.1672 14.8124H12.5C12.1062 14.8124 11.7969 14.503 11.7969 14.1093V9.89062C11.7969 9.49682 12.1062 9.1875 12.5 9.1875H23.6C23.9375 9.1875 24.2328 9.42651 24.2891 9.76401C24.4297 10.4953 24.5 11.2546 24.5 12V12Z",
    fill: "#4086F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1672 14.8124C17.7172 15.7405 17.0281 16.528 16.2125 17.1187L20.2203 21.1264C22.8079 18.9327 24.5 15.6562 24.5 12C24.5 11.2546 24.4297 10.4953 24.289 9.76401C24.2328 9.42651 23.9375 9.1875 23.6 9.1875H12.5V14.8124H18.1672Z",
    fill: "#4175DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4194 3.35148C20.4335 3.54835 20.3491 3.73121 20.2226 3.87179L17.2132 6.86706C16.9742 7.12019 16.5804 7.14831 16.2992 6.93738C15.1881 6.10774 13.8803 5.67181 12.5022 5.67181C9.66157 5.67181 7.24287 7.57018 6.44131 10.1577L2.2085 5.92493C4.2897 2.40935 8.12881 0 12.5022 0C15.3007 0 18.0288 1.03124 20.1663 2.83117C20.321 2.95778 20.4054 3.15461 20.4194 3.35148V3.35148Z",
    fill: "#FF641A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2969 6.93738C16.5781 7.14836 16.9718 7.12019 17.2109 6.86707L20.2203 3.87179C20.3469 3.73121 20.4312 3.5484 20.4171 3.35148C20.403 3.15456 20.3187 2.95778 20.164 2.83117C18.0266 1.03124 15.2984 0 12.5 0V5.67181C13.8781 5.67181 15.1859 6.10775 16.2969 6.93738Z",
    fill: "#F03800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.fe0ba6d3b9ef12db0e1fa23136a16f59.svg";
export { ForwardRef as ReactComponent };